import React, {Fragment, useState} from 'react';
import {Link} from 'react-router-dom';

import Tooltip from '@material-ui/core/Tooltip';
import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ListSubheader from '@material-ui/core/ListSubheader';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import {makeStyles} from '@material-ui/core/styles';

import {pathResolver} from '@helpers/RoutePathHelper';

const useStyles = makeStyles((theme) => ({
  nested: {
    paddingLeft: theme.spacing(4),
    backgroundColor: "#d5d5d5"
  },
  acompanhamento: {
    paddingLeft: '24px',
    backgroundColor: '#3f51b5',
    borderTopLeftRadius: '20px',
    borderBottomLeftRadius: '20px',
    color: '#fff',
    marginLeft: '10px',
    marginTop: '10px',
    boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.2)'
  }
}));

export const CollapseItems = (props) => {
  const classes = useStyles();
  return (
    <Collapse in={props.open} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        {props.items.map((item, key) =>
          item.showOnMenu ?
          <ListItem button
                    className={classes.nested}
                    to={pathResolver(item.path, item.params)}
                    component={Link}
                    key={key}
          >
            <ListItemIcon>
              <Tooltip title={item.name} placement="right" enterDelay={200} leaveDelay={200} arrow>
                {<item.icon/>}
              </Tooltip>
            </ListItemIcon>
            <ListItemText primary={item.name}/>
          </ListItem>
            : <></>
        )}
      </List>
    </Collapse>
  )
}

export const ListDrawer = (props) => {
  const [open, setOpen] = useState(false);
  const classes = useStyles();

  const handleClick = () => {
    setOpen(!open);
  };

  const hideMenuInicio = () => true;

  return (
    <>
      <List
        component="nav"
        aria-labelledby="nested-list-subheader"
        subheader={
          <ListSubheader component="div" id="nested-list-subheader">
            {props.category}
          </ListSubheader>}
      >
        {props.items.map((item, key) =>

          item.showOnMenu ?
            hideMenuInicio(item) ?
              item.collapsed ?
                <Fragment key={key}>
                  <ListItem button
                            key={key}
                            onClick={handleClick}
                            style={{paddingLeft: '24px'}}
                  >
                    <ListItemIcon>
                      <Tooltip title={item.name} placement="right" enterDelay={200} leaveDelay={200} arrow>
                        {<item.icon/>}
                      </Tooltip>
                    </ListItemIcon>
                    <ListItemText primary={item.name}/>
                    {open ? <ExpandLess/> : <ExpandMore/>}
                  </ListItem>
                  {item.divider ? <Divider/> : null}
                  <CollapseItems
                    open={open}
                    items={item.submenus}
                  />
                </Fragment>
                :
                item.name === 'Acompanhamento' ?
                  <ListItem button
                            to={pathResolver(item.path, item.params)}
                            component={Link}
                            key={key}
                            className={classes.acompanhamento}
                  >
                    <ListItemIcon>
                      <Tooltip title={item.name} placement="right" enterDelay={200} leaveDelay={200} arrow>
                        {<item.icon style={{color: '#fff'}}/>}
                      </Tooltip>
                    </ListItemIcon>
                    <ListItemText primary={item.name}/>
                  </ListItem>
                  :
                  <>
                    <ListItem button
                              to={pathResolver(item.path, item.params)}
                              component={Link}
                              key={key}
                              style={{paddingLeft: '24px'}}
                    >
                      <ListItemIcon>
                        <Tooltip title={item.name} placement="right" enterDelay={200} leaveDelay={200} arrow>
                          {<item.icon/>}
                        </Tooltip>
                      </ListItemIcon>
                      <ListItemText primary={item.name}/>
                    </ListItem>
                    {item.divider ? <Divider/> : null}
                  </>
              : null
            : null
        )}
      </List>

      {(props.items.some((item) => hideMenuInicio(item)))}
    </>
  );
}

export default ListDrawer;
